import { render, staticRenderFns } from "./page-work-masonry.vue?vue&type=template&id=7c04794a&"
import script from "./page-work-masonry.vue?vue&type=script&lang=js&"
export * from "./page-work-masonry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports